import { Component, Input, DoCheck, Output, EventEmitter, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { LocaStockService } from '../../../service/loca-stock/loca-stock.service';
import { ItemService } from '../../../service/item/item.service';
import { CommonService } from '../../../service/common/common.service';
import { validation } from '../../../util/validation';
import { validateMaxByteLength } from '../../../util/validation';
import { OwnerService } from '../../../service/owner/owner.service';

import { Router } from '@angular/router';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import * as moment from 'moment';

@Component({
  selector: 'wa6011',
  templateUrl: 'wa6011.component.html',
  styleUrls: ['wa6011.component.scss']
})
export class Wa6011Component implements OnChanges {
  @ViewChild('scrollContent')
  scrollContent: ElementRef;

  @Input()
  private Selectoption: any;
  @Input()
  private selectedRowData: any;

  @Input()
  private isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  public itemCd: FormControl;
  public itemTx: FormControl;

  public originalDt: FormControl;
  public bookDt: FormControl;
  public itemId: number;
  public lotTx: FormControl;
  public uselimitDt: FormControl;
  public isUselimitDt = false;    // 期限管理する商品の場合はtrue
  public notNeedStockDt = false;   // 入庫日管理しない場合はtrue
  public stockDt: FormControl;
  public stockNr: number;
  public caseStockNr: FormControl;
  public innerStockNr: FormControl;
  public baraStockNr: FormControl;
  public typeoperationCheck: FormControl;
  public stockinoutmemoTx: FormControl;
  public validation = validation;
  private errorInfo = '';
  public rowData: any[];
  private autoloadvalue: string = '';
  private SearchList;
  private dspnone: boolean = true;
  private autoloadClassActive: boolean = false;
  private autoloadClassDisabled: boolean = true;
  private autoloadClassError: boolean = false;
  private ownerTx: FormControl;
  private Options: any;
  private OwnerTxActive: boolean = false;
  private OwnerTxDisabled: boolean = false;
  private OwnerTxError: boolean;
  private eventvalue: string = '';
  private ErrorOwnerTx: string;
  private Result: number;
  private itemCdErrorInfo: string;
  private ExecuteDisabled: boolean = true;
  private disabled: boolean = true;
  private disable: boolean = false;
  private caseamountNr: number;
  private inneramountNr: number;
  private stockDtselectOption: FormControl;
  private onInitData: boolean = false;

  private owners: any;

  private isShow0010 = false;
  private SearchItemDisabled: boolean = true;
  private isSubmitButtonEnabled = false;

  @ViewChild('wa0010')
  wa0010: any

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private locaStockService: LocaStockService,
    private commonService: CommonService,
    private ownerService: OwnerService,
    private itemService: ItemService,
    private dialogsService: DialogsService
  ) {
    this.originalDt = new FormControl(new Date().toJSON().slice(0, 10), [Validators.required]);
    this.bookDt = new FormControl(new Date().toJSON().slice(0, 10), [Validators.required]);
    this.lotTx = new FormControl('', [validateMaxByteLength(validation.lotTx.maxByteLength)]);
    this.uselimitDt = new FormControl(new Date('2099-01-01').toJSON().slice(0, 10), [Validators.required]);
    this.stockDt = new FormControl(new Date('2000-01-01').toJSON().slice(0, 10), [Validators.required]);

    this.caseStockNr = new FormControl(validation.stockNr.minNr, [
      Validators.required,
      Validators.pattern(validation.integer),
      Validators.min(validation.stockNr.minNr),
      Validators.max(validation.stockNr.maxNr)
    ]);
    this.innerStockNr = new FormControl(validation.stockNr.minNr, [
      Validators.required,
      Validators.pattern(validation.integer),
      Validators.min(validation.stockNr.minNr),
      Validators.max(validation.stockNr.maxNr)
    ]);
    this.baraStockNr = new FormControl(validation.stockNr.minNr, [
      Validators.required,
      Validators.pattern(validation.integer),
      Validators.min(validation.stockNr.minNr),
      Validators.max(validation.stockNr.maxNr)
    ]);
    this.typeoperationCheck = new FormControl('');
    this.stockinoutmemoTx = new FormControl('', [Validators.maxLength(validation.stockinoutmemoTx.maxLength)]);
    this.stockDtselectOption = new FormControl('1');
    this.itemCd = new FormControl('');
    this.itemTx = new FormControl('');
    this.ownerTx = new FormControl('');
    this.itemTx.disable();
    this.itemCd.disable();

    sessionStorage.removeItem('open_regist');
    this.originalDt.disable();
    this.bookDt.disable();
    this.stockDt.disable();
    this.lotTx.disable();
    this.uselimitDt.disable();
    this.caseStockNr.disable();
    this.innerStockNr.disable();
    this.baraStockNr.disable();
    this.stockinoutmemoTx.disable();
    this.stockDtselectOption.disable();

    this.ownerService
      .get()
      .then(outputJson => {
        this.owners = outputJson.owners;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  execute() {
    if (moment(moment().format('YYYY-MM-DD')) > moment(this.uselimitDt.value)) {
      this.dialogsService.confirm('確認', '商品の使用期限が切れていますが登録しますか。').subscribe(res => {
        if (res === true) {
          this.execute2()
        }
      });
    } else {
      this.execute2()
    }
  }
  execute2() {
    this.ExecuteDisabled = false;
    this.isSubmitButtonEnabled = false;
    if (this.autoloadvalue === '' || this.stockNr === 0 || this.originalDt.value === this.bookDt) {
      return;
    }

    let errors = false;
    if (this.OwnerTxError === true) {
      this.ownerTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.itemCdErrorInfo !== '') {
      this.itemCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.originalDt.errors !== null) {
      this.originalDt.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bookDt.errors !== null) {
      this.bookDt.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.lotTx.errors !== null) {
      this.lotTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.uselimitDt.errors !== null) {
      this.uselimitDt.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.stockDt.errors !== null) {
      this.stockDt.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseStockNr.errors !== null) {
      this.caseStockNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.innerStockNr.errors !== null) {
      this.innerStockNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.baraStockNr.errors !== null) {
      this.baraStockNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.stockinoutmemoTx.errors !== null) {
      this.stockinoutmemoTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    let typeoperation = '700';
    if (this.stockNr < 0) {
      typeoperation = this.typeoperationCheck.value === true ? '710' : '720';
    } else {
      typeoperation = this.typeoperationCheck.value === true ? '730' : '700';
    }

    this.locaStockService
      .post(
        this.originalDt.value,
        this.bookDt.value,
        this.selectedRowData.locaId,
        this.itemId,
        this.lotTx.value.trim(),
        this.uselimitDt.value,
        this.stockDt.value,
        this.stockNr,
        typeoperation,
        this.stockinoutmemoTx.value.trim(),
        'wa6011'
      )
      .then(outputJson => {
        this.closeButtonClick.emit(true);
        this.disabled = true;
        this.ExecuteDisabled = true;
        this.isSubmitButtonEnabled = true;
        this.Cancel();
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.ExecuteDisabled = true;
        this.isSubmitButtonEnabled = true;
      });
  }

  ngDoCheck() {
    if (this.isShow === false) {
      return;
    }
    if (this.eventvalue === '0') {
      this.Options = [];
      this.OwnerTxActive = false;
    }

    if (this.chkRequired()) {
      this.ExecuteDisabled = false;
    } else {
      this.ExecuteDisabled = true;
    }

    this.stockNr = ((this.caseStockNr.value * this.caseamountNr) + (this.innerStockNr.value * this.inneramountNr) + this.baraStockNr.value) ?
                    ((this.caseStockNr.value * this.caseamountNr) + (this.innerStockNr.value * this.inneramountNr) + this.baraStockNr.value) : 0;
  }

  searchItem() {
    this.errorInfo = '';
    this.isShow0010 = true;
  }

  onClose0010(selectedNodeData: any) {
    this.isShow0010 = false;
    if (selectedNodeData != null) {
      this.errorInfo = '';
      let item = selectedNodeData;
      this.itemId = item.itemId;
      this.itemCd.setValue(item.itemCd);
      this.itemTx.setValue(item.itemTx);
      this.caseamountNr = item.caseamountNr;
      this.inneramountNr = item.inneramountNr;
      this.autoloadvalue = item.itemCd;
      this.autoloadClassActive = true;
      this.autoloadClassError = false;
      this.itemCdErrorInfo = '';
      this.disabled = false;
      this.originalDt.enable();
      this.bookDt.enable();
      this.stockDt.enable();
      this.lotTx.enable();
      this.uselimitDt.enable();
      this.caseStockNr.enable();
      this.innerStockNr.enable();
      this.baraStockNr.enable();
      this.stockinoutmemoTx.enable();
      if(this.stockDtselectOption.value === '0'){
        this.stockDtselectOption.enable();
      }
      this.chgStockDtselectOption();
      if(item.uselimitFl == 1){
        this.isUselimitDt = true;
      }else{
        this.isUselimitDt = false;
        this.uselimitDt = new FormControl(new Date('2099-01-01').toJSON().slice(0, 10), [Validators.required]);
      }
    }
  }

  ExecuteClass() {
    let Isclass = {
      'btn_primary': true,
      'disabled': this.ExecuteDisabled
    }
    return Isclass;
  }
  SearchItemClass() {
    let Isclass = {
      'btn_primary': true,
      'disabled': this.SearchItemDisabled
    }
    return Isclass;
  }

  ownerSearchByItem(ownerId) {
    let parameter;

    if (ownerId !== '') {
      parameter = 'ownerId=' + ownerId;
    } else {
      parameter = undefined;
    }

    this.itemService
      .get(parameter)
      .then(outputJson => {
        console.log(outputJson);
        this.Selectoption = outputJson.items;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  OwnerTx(event) {
    this.errorInfo = '';
    setTimeout(() => {
      if (event.target.value !== '0') {
        this.autoloadClassDisabled = false;
        this.itemCd.disable();
        this.OwnerTxActive = true;
        this.SearchItemDisabled = false;
        this.setStockDtselectOption(event.target.value);
      } else {
        this.autoloadClassDisabled = true;
        this.itemCd.disable();
        this.SearchItemDisabled = true;
      }
      this.itemCd.setValue('');
      this.itemTx.setValue('');
      this.autoloadvalue = '';
    }, 300);
    this.eventvalue = event.target.value;
    this.wa0010.resetData()
  }

  setStockDtselectOption(OwnerId){
    this.ownerService
    .getNeedStockDt(OwnerId)
    .then(needStockDt => {
      this.notNeedStockDt = !needStockDt;
      if(this.notNeedStockDt === true){ // 入庫日管理しない
        this.stockDtselectOption = new FormControl('1');
        this.stockDtselectOption.disable();
      } else {
        this.stockDtselectOption = new FormControl('0');
        this.stockDtselectOption.enable();
      }
    })
    .catch(error => {
      console.log(this.commonService.getErrorMessage(error));
      this.errorInfo = this.commonService.getErrorMessage(error);
    });
  }

  OwnerTxClass() {
    let Isclass = {
      content: true,
      'otherwindow-contents__inputarea__input__sep--select': true,
      disabled: this.OwnerTxDisabled,
      active: this.OwnerTxActive,
      error: this.OwnerTxError
    };
    return Isclass;
  }

  otherwindow_regist() {
    let open_regist: boolean = false;
    let dsp_regist: boolean = true;
    if (sessionStorage.getItem('open_regist') === '1') {
      open_regist = true;
      dsp_regist = false;
    } else {
      open_regist = false;
      dsp_regist = true;
    }
    let Isclass = {
      otherwindow: true,
      openotherwindow: open_regist,
      dspnone: dsp_regist
    };
    return Isclass;
  }

  Cancel() {
    sessionStorage.setItem('isShowOwnerSelect', 'true');
    this.onInitData = false;
    this.autoloadvalue = '';
    this.autoloadClassActive = false;
    this.autoloadClassError = false;
    this.disabled = true;
    this.disable = false;
    this.errorInfo = '';
    this.originalDt = new FormControl(new Date().toJSON().slice(0, 10), [Validators.required]);
    this.bookDt = new FormControl(new Date().toJSON().slice(0, 10), [Validators.required]);
    this.lotTx = new FormControl('', [validateMaxByteLength(validation.lotTx.maxByteLength)]);
    this.uselimitDt = new FormControl(new Date('2099-01-01').toJSON().slice(0, 10), [Validators.required]);
    this.stockDt = new FormControl(new Date().toJSON().slice(0, 10), [Validators.required]);
    this.caseStockNr = new FormControl(validation.stockNr.minNr, [
      Validators.pattern(validation.integerPlus),
      Validators.max(validation.stockNr.maxNr),
      Validators.min(validation.stockNr.minNr)
    ]);
    this.innerStockNr = new FormControl(validation.stockNr.minNr, [
      Validators.pattern(validation.integerPlus),
      Validators.max(validation.stockNr.maxNr),
      Validators.min(validation.stockNr.minNr)
    ]);
    this.baraStockNr = new FormControl(validation.stockNr.minNr, [
      Validators.pattern(validation.integerPlus),
      Validators.max(validation.stockNr.maxNr),
      Validators.min(validation.stockNr.minNr)
    ]);
    this.stockinoutmemoTx = new FormControl('', [Validators.maxLength(validation.stockinoutmemoTx.maxLength)]);
    this.stockDtselectOption = new FormControl('1');
    this.itemCd = new FormControl('');
    this.itemTx = new FormControl('');
    this.originalDt.disable();
    this.bookDt.disable();
    this.lotTx.disable();
    this.uselimitDt.disable();
    this.stockDt.disable();
    this.caseStockNr.disable();
    this.innerStockNr.disable();
    this.isUselimitDt = false;
    this.baraStockNr.disable();
    this.stockinoutmemoTx.disable();
    this.stockDtselectOption.disable();
    this.itemCd.disable();
    this.ownerTx = new FormControl('0');
    this.OwnerTxActive = false;
    this.autoloadClassDisabled = true;
    this.itemCdErrorInfo = '';
    this.closeButtonClick.emit(false);
  }

  SearchulClass() {
    let Isclass = {
      autoloader: true,
      tl: true,
      dspnone: this.dspnone
    };
    return Isclass;
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      setTimeout(() => {
        this.initDatas();
      }, 500);
    } else {
      setTimeout(() => {
        this.scrollContent.nativeElement.scrollTop = 0;
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    let ownerResult = sessionStorage.getItem('ownerResult');
    if (ownerResult !== null) {
      const selectedOwner = JSON.parse(ownerResult);
      if (selectedOwner.ownerdisplayTx === 'ALL') sessionStorage.setItem('ownerTx', 'ALL');
      //SW-1887 ロケ在庫照会で荷主が選択されていたら、荷主をセットし、商品一覧を取得
      if (selectedOwner.ownerTx !== 'ALL') {
          this.ownerTx.setValue(selectedOwner.ownerId ? selectedOwner.ownerId : 0);
          setTimeout(() => {
          if (this.ownerTx.value !== '0') {
            this.autoloadClassDisabled = false;
            this.itemCd.disable();
            this.OwnerTxActive = true;
            this.SearchItemDisabled = false;
            this.setStockDtselectOption(this.ownerTx.value);
          } else {
            this.autoloadClassDisabled = true;
            this.itemCd.disable();
            this.SearchItemDisabled = true;
          }
        }, 300);
        this.eventvalue = this.ownerTx.value;
        }
      this.ownerTx.disable();
    } else {
      this.ownerTx.enable();
      this.ownerTx.setValue(0)
      this.SearchItemDisabled = true;
    };
    this.SearchItemClass();
    this.itemCd.setValue('');
    this.itemTx.setValue('');
  }

  onSumStock() {
    this.errorInfo = '';

    // if (this.caseStockNr.value < 0 || this.caseStockNr.value == null) this.caseStockNr.setValue(0);
    // if (this.baraStockNr.value < 0 || this.baraStockNr.value == null) this.baraStockNr.setValue(0);
  }

  clrErr() {
    this.errorInfo = '';
  }

  chkRequired() {
    if (this.autoloadvalue === '') {
      return false;
    }
    if (this.ownerTx.value === '0') {
      return false;
    }
    if (this.itemCd.value === '') {
      return false;
    }
    if (this.originalDt.errors !== null) {
      return false;
    }
    if (this.bookDt.errors !== null) {
      return false;
    }
    if (this.stockDtselectOption.value === '0' && this.stockDt.errors !== null) {
      return false;
    }
    if (this.stockNr == 0) {
      return false;
    }
    if (this.stockinoutmemoTx.errors !== null) {
      return false;
    }
    if (this.lotTx.errors !== null) {
      return false;
    }
    if (this.uselimitDt.errors !== null) {
      return false;
    }

    return true;
  }

  chgStockDtselectOption() {
    this.clrErr();
    if (this.autoloadClassActive == true) {
      if (this.stockDtselectOption.value === '1') {
        this.stockDt.disable();
        this.disable = true;
        this.stockDt.setValue(new Date('2000-01-01').toJSON().slice(0, 10));
      } else {
        this.stockDt.setValue(new Date().toJSON().slice(0, 10));
        this.stockDt.enable();
        this.disable = false;
      }
    }
  }
}

class ItemDetail {
  public itemId: string;
  public itemCd: FormControl;
  public itemTx: FormControl;
  public caseamountNr: number;
  public inneramountNr: number;
   constructor(det?: any) {
    if (!det) {
      det = {
        itemId: 0,
        caseamountNr: null,
        inneramountNr: null
      };
    }
    this.itemId = det.itemId;
    this.itemCd = new FormControl(det.itemCd || '', [Validators.required]);
    this.itemTx = new FormControl(det.itemTx || '', [Validators.required]);
    this.caseamountNr = det.caseamountNr;
    this.inneramountNr = det.inneramountNr;
  }

  toJson(): object {
    return {
      itemId: this.itemId,
      itemCd: this.itemCd.value,
      itemTx: this.itemTx.value,
      caseamountNr: this.caseamountNr,
      inneramountNr: this.inneramountNr
    };
  }
}
  


// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6011/wa6011.component.ts